export const AUTH_ROUTE = '/auth';
